module.exports = __webpack_public_path__ + "img/组织竞价.9a362dac.png";